import productModel from "./product";
import Config from "@/config.js"

export default class {
  constructor() {
    this.id = 0;
    this.products = [];
    this.translations = {};
    this.additionnalEquipment = false;
  }

  hydrate(data) {
    if (void 0 !== data.id) this.id = data.id;
    if (void 0 !== data.translations) this.translations = data.translations;
    if (void 0 !== data.additionnalEquipment && data.additionnalEquipment) this.additionnalEquipment = data.additionnalEquipment;

    if (data.products) {
      for (let p of data.products) {
        const _p = new productModel();
        _p.hydrate(p);
        _p.tvaRate = Config.TVA_RATE;
        _p.type = {
          id: this.id,
          translations: this.translations,
        };
        this.products.push(_p);
      }
    }
  }
}
